module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app-layout', [_c('div', {
    slot: "header"
  }, [_c('v-sub-header', [_c('template', {
    slot: "header"
  }, [_vm._v("\n        Avoimet tarjouspyynnöt\n      ")])], 2)], 1), _vm._v(" "), _c('v-bloc', [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('v-vuetable-container', [_c('vuetable', {
    staticClass: "mg-md",
    attrs: {
      "css": _vm.css,
      "api-url": _vm.url + '/quotes',
      "fields": _vm.fields,
      "query-params": _vm.params,
      "no-data-template": _vm.noDataTemplate(this.loading, 'Ei saapuneita tarjouspyyntöjä.')
    },
    on: {
      "vuetable:loaded": _vm.onLoading
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function(props) {
        return [_c('router-link', {
          staticClass: "btn btn-sm btn-deep-magenta pull-right",
          attrs: {
            "to": {
              name: 'make-offer.index',
              params: {
                quoteId: props.rowData.id
              }
            }
          }
        }, [_vm._v("\n              Tee tarjous\n            ")])]
      }
    }])
  }), _vm._v(" "), (_vm.loading) ? _c('v-spinner') : _vm._e()], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-435b4bbf"}!./src/app/pages/received-quotes/received-quotes.html
// module id = 474
// module chunks = 1